/* tslint:disable */
/* eslint-disable */
/**
 * grpc/meetings/service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { MeetingsCheckManagerAvailabilityResponse } from '../models'
// @ts-ignore
import { MeetingsGetHealthResponse } from '../models'
// @ts-ignore
import { MeetingsGetInviteTextResponse } from '../models'
// @ts-ignore
import { MeetingsGetRecordingAudioUrlResponse } from '../models'
// @ts-ignore
import { MeetingsListMeetingInvitesResponse } from '../models'
// @ts-ignore
import { MeetingsListMeetingRecordingsResponse } from '../models'
// @ts-ignore
import { MeetingsListMeetingsResponse } from '../models'
// @ts-ignore
import { MeetingsMeeting } from '../models'
// @ts-ignore
import { MeetingsMeetingsStatsResponse } from '../models'
// @ts-ignore
import { MeetingsQualificationResponse } from '../models'
// @ts-ignore
import { MeetingsScheduleMeetingRequest } from '../models'
// @ts-ignore
import { MeetingsServiceApplyQualificationBody } from '../models'
// @ts-ignore
import { MeetingsServiceCancelMeetingBody } from '../models'
// @ts-ignore
import { MeetingsServiceGetInviteTextBody } from '../models'
// @ts-ignore
import { MeetingsServiceRescheduleMeetingBody } from '../models'
// @ts-ignore
import { MeetingsServiceResendInviteBody } from '../models'
// @ts-ignore
import { RpcStatus } from '../models'
/**
 * MeetingsServiceApi - axios parameter creator
 * @export
 */
export const MeetingsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Применяет выбранные предложения к карточке клиента. Правка карточки — это работа менеджера, поэтому meetings:manage, а не чтение.
     * @param {string} meetingId
     * @param {MeetingsServiceApplyQualificationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceApplyQualification: async (
      meetingId: string,
      body: MeetingsServiceApplyQualificationBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceApplyQualification', 'meetingId', meetingId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceApplyQualification', 'body', body)
      const localVarPath = `/api/v1/meetings/{meetingId}/qualification/apply`.replace(
        `{${'meetingId'}}`,
        encodeURIComponent(String(meetingId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Отменяет встречу: событие убирается из календаря, клиенту уходит уведомление об отмене. Встреча остаётся видимой со статусом CANCELLED.
     * @param {string} id
     * @param {MeetingsServiceCancelMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceCancelMeeting: async (
      id: string,
      body: MeetingsServiceCancelMeetingBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('meetingsServiceCancelMeeting', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceCancelMeeting', 'body', body)
      const localVarPath = `/api/v1/meetings/{id}/cancel`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Занятость менеджера в выбранном слоте — предупреждение в модалке назначения. Ответ смотрит в календарь целиком, а не только в наши встречи: менеджер занят и своим отпуском, и чужой планёркой.
     * @param {string} [managerId] Пусто — календарь того, кто спрашивает.
     * @param {string} [scheduledStart]
     * @param {string} [scheduledEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceCheckManagerAvailability: async (
      managerId?: string,
      scheduledStart?: string,
      scheduledEnd?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/meetings/availability`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (scheduledStart !== undefined) {
        localVarQueryParameter['scheduledStart'] =
          (scheduledStart as any) instanceof Date
            ? (scheduledStart as any).toISOString()
            : scheduledStart
      }

      if (scheduledEnd !== undefined) {
        localVarQueryParameter['scheduledEnd'] =
          (scheduledEnd as any) instanceof Date ? (scheduledEnd as any).toISOString() : scheduledEnd
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Отклоняет черновик целиком: карточка остаётся как была.
     * @param {string} meetingId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceDiscardQualification: async (
      meetingId: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceDiscardQualification', 'meetingId', meetingId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceDiscardQualification', 'body', body)
      const localVarPath = `/api/v1/meetings/{meetingId}/qualification/discard`.replace(
        `{${'meetingId'}}`,
        encodeURIComponent(String(meetingId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetHealth: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/meetings/health`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Отдаёт текст приглашения для ручной отправки — кнопка «Скопировать». Отметка mark_sent заводит отправку с каналом MANUAL_COPY: без неё встречи с клиентом без подключённых каналов выпали бы из учёта уведомлений.
     * @param {string} meetingId
     * @param {MeetingsServiceGetInviteTextBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetInviteText: async (
      meetingId: string,
      body: MeetingsServiceGetInviteTextBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceGetInviteText', 'meetingId', meetingId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceGetInviteText', 'body', body)
      const localVarPath = `/api/v1/meetings/{meetingId}/invites/text`.replace(
        `{${'meetingId'}}`,
        encodeURIComponent(String(meetingId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetMeeting: async (
      id: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('meetingsServiceGetMeeting', 'id', id)
      const localVarPath = `/api/v1/meetings/{id}`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Сводка над списком встреч по тому же фильтру и с тем же скоупом, что ListMeetings (DEV-2085). Ниже GetMeeting намеренно — см. предупреждение о порядке методов выше.
     * @param {string} [clientId]
     * @param {string} [dealId]
     * @param {string} [managerId]
     * @param {Array<MeetingsServiceGetMeetingsStatsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
     * @param {Array<MeetingsServiceGetMeetingsStatsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
     * @param {string} [startFrom]
     * @param {string} [startTo]
     * @param {Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>} [leadTemperatures]  - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
     * @param {number} [minUsefulness]
     * @param {string} [clientQuery]
     * @param {boolean} [pendingSuggestions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetMeetingsStats: async (
      clientId?: string,
      dealId?: string,
      managerId?: string,
      providers?: Array<MeetingsServiceGetMeetingsStatsProvidersEnum>,
      statuses?: Array<MeetingsServiceGetMeetingsStatsStatusesEnum>,
      startFrom?: string,
      startTo?: string,
      leadTemperatures?: Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>,
      minUsefulness?: number,
      clientQuery?: string,
      pendingSuggestions?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/meetings/stats`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (clientId !== undefined) {
        localVarQueryParameter['clientId'] = clientId
      }

      if (dealId !== undefined) {
        localVarQueryParameter['dealId'] = dealId
      }

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (providers) {
        localVarQueryParameter['providers'] = providers
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses
      }

      if (startFrom !== undefined) {
        localVarQueryParameter['startFrom'] =
          (startFrom as any) instanceof Date ? (startFrom as any).toISOString() : startFrom
      }

      if (startTo !== undefined) {
        localVarQueryParameter['startTo'] =
          (startTo as any) instanceof Date ? (startTo as any).toISOString() : startTo
      }

      if (leadTemperatures) {
        localVarQueryParameter['leadTemperatures'] = leadTemperatures
      }

      if (minUsefulness !== undefined) {
        localVarQueryParameter['minUsefulness'] = minUsefulness
      }

      if (clientQuery !== undefined) {
        localVarQueryParameter['clientQuery'] = clientQuery
      }

      if (pendingSuggestions !== undefined) {
        localVarQueryParameter['pendingSuggestions'] = pendingSuggestions
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Черновик разбора встречи: что модель услышала и чем это отличается от карточки клиента. Право meetings:read.
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetQualification: async (
      meetingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceGetQualification', 'meetingId', meetingId)
      const localVarPath = `/api/v1/meetings/{meetingId}/qualification`.replace(
        `{${'meetingId'}}`,
        encodeURIComponent(String(meetingId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Короткоживущая ссылка на аудио записи — источник для плеера. Сам файл наружу не отдаём: ссылка живёт минуты и берётся заново.
     * @param {string} meetingId
     * @param {string} recordingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetRecordingAudioUrl: async (
      meetingId: string,
      recordingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceGetRecordingAudioUrl', 'meetingId', meetingId)
      // verify required parameter 'recordingId' is not null or undefined
      assertParamExists('meetingsServiceGetRecordingAudioUrl', 'recordingId', recordingId)
      const localVarPath = `/api/v1/meetings/{meetingId}/recordings/{recordingId}/audio-url`
        .replace(`{${'meetingId'}}`, encodeURIComponent(String(meetingId)))
        .replace(`{${'recordingId'}}`, encodeURIComponent(String(recordingId)))
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Отправки приглашения по встрече: бейджи доставки в блоке «Видеовстречи».
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceListMeetingInvites: async (
      meetingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceListMeetingInvites', 'meetingId', meetingId)
      const localVarPath = `/api/v1/meetings/{meetingId}/invites`.replace(
        `{${'meetingId'}}`,
        encodeURIComponent(String(meetingId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     * Право meetings:read_recordings, а не meetings:read: содержание разговора с клиентом узкее, чем факт встречи. Кто видит встречу, не обязан слышать, о чём на ней говорили.
     * @summary Записи встречи вместе с расшифровками — пост-мит экран.
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceListMeetingRecordings: async (
      meetingId: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceListMeetingRecordings', 'meetingId', meetingId)
      const localVarPath = `/api/v1/meetings/{meetingId}/recordings`.replace(
        `{${'meetingId'}}`,
        encodeURIComponent(String(meetingId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Встречи по фильтру: блок «Видеовстречи» в карточке клиента и сделки.
     * @param {string} [clientId]
     * @param {string} [dealId]
     * @param {string} [managerId] Пусто — встречи всех менеджеров, которых видит вызывающий.
     * @param {Array<MeetingsServiceListMeetingsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
     * @param {Array<MeetingsServiceListMeetingsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
     * @param {string} [startFrom] Окно начала встречи.
     * @param {string} [startTo]
     * @param {boolean} [sortDesc] По умолчанию ближайшие сверху; для истории встреч — обратный порядок. При сортировке по оценкам «desc» значит «лучшие сверху».
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>} [leadTemperatures] Фильтры раздела «Видеовстречи» (DEV-2085). Встречи без разбора под фильтры по оценкам не попадают.   - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
     * @param {number} [minUsefulness] Полезность от N (1–5); ноль — не сужать.
     * @param {string} [clientQuery] Поиск по имени клиента: слова запроса как префиксы.
     * @param {MeetingsServiceListMeetingsSortByEnum} [sortBy]
     * @param {boolean} [pendingSuggestions] Только встречи с неразобранными предложениями ИИ (DEV-2831) — те, что считает MeetingsStatsResponse.pending_suggestions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceListMeetings: async (
      clientId?: string,
      dealId?: string,
      managerId?: string,
      providers?: Array<MeetingsServiceListMeetingsProvidersEnum>,
      statuses?: Array<MeetingsServiceListMeetingsStatusesEnum>,
      startFrom?: string,
      startTo?: string,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      leadTemperatures?: Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>,
      minUsefulness?: number,
      clientQuery?: string,
      sortBy?: MeetingsServiceListMeetingsSortByEnum,
      pendingSuggestions?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/meetings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (clientId !== undefined) {
        localVarQueryParameter['clientId'] = clientId
      }

      if (dealId !== undefined) {
        localVarQueryParameter['dealId'] = dealId
      }

      if (managerId !== undefined) {
        localVarQueryParameter['managerId'] = managerId
      }

      if (providers) {
        localVarQueryParameter['providers'] = providers
      }

      if (statuses) {
        localVarQueryParameter['statuses'] = statuses
      }

      if (startFrom !== undefined) {
        localVarQueryParameter['startFrom'] =
          (startFrom as any) instanceof Date ? (startFrom as any).toISOString() : startFrom
      }

      if (startTo !== undefined) {
        localVarQueryParameter['startTo'] =
          (startTo as any) instanceof Date ? (startTo as any).toISOString() : startTo
      }

      if (sortDesc !== undefined) {
        localVarQueryParameter['sortDesc'] = sortDesc
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      if (leadTemperatures) {
        localVarQueryParameter['leadTemperatures'] = leadTemperatures
      }

      if (minUsefulness !== undefined) {
        localVarQueryParameter['minUsefulness'] = minUsefulness
      }

      if (clientQuery !== undefined) {
        localVarQueryParameter['clientQuery'] = clientQuery
      }

      if (sortBy !== undefined) {
        localVarQueryParameter['sortBy'] = sortBy
      }

      if (pendingSuggestions !== undefined) {
        localVarQueryParameter['pendingSuggestions'] = pendingSuggestions
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Разбирает встречу заново по сохранённой расшифровке — кнопка «Разобрать заново» (DEV-2085): для встреч, разобранных до появления оценок, и после правки промпта. Применённый черновик не трогает, неприменённый пересобирает. Право meetings:manage: разбор платный.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceRequalifyMeeting: async (
      id: string,
      body: object,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('meetingsServiceRequalifyMeeting', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceRequalifyMeeting', 'body', body)
      const localVarPath = `/api/v1/meetings/{id}/requalify`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Переносит встречу на другое время. Приглашение клиенту переотправляется: у Meet обновление рассылает сам Calendar, остальные каналы — Ф2.
     * @param {string} id
     * @param {MeetingsServiceRescheduleMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceRescheduleMeeting: async (
      id: string,
      body: MeetingsServiceRescheduleMeetingBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('meetingsServiceRescheduleMeeting', 'id', id)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceRescheduleMeeting', 'body', body)
      const localVarPath = `/api/v1/meetings/{id}/reschedule`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Отправляет клиенту приглашение ещё раз — кнопка «Отправить повторно». Каждая попытка остаётся отдельной строкой: неудачную не затираем.
     * @param {string} meetingId
     * @param {MeetingsServiceResendInviteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceResendInvite: async (
      meetingId: string,
      body: MeetingsServiceResendInviteBody,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'meetingId' is not null or undefined
      assertParamExists('meetingsServiceResendInvite', 'meetingId', meetingId)
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceResendInvite', 'body', body)
      const localVarPath = `/api/v1/meetings/{meetingId}/invites/resend`.replace(
        `{${'meetingId'}}`,
        encodeURIComponent(String(meetingId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary Назначает видеовстречу: заводит конференцию у провайдера, включает в ней запись и кладёт встречу в карточку клиента. Право meetings:manage.
     * @param {MeetingsScheduleMeetingRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceScheduleMeeting: async (
      body: MeetingsScheduleMeetingRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('meetingsServiceScheduleMeeting', 'body', body)
      const localVarPath = `/api/v1/meetings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * MeetingsServiceApi - functional programming interface
 * @export
 */
export const MeetingsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = MeetingsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Применяет выбранные предложения к карточке клиента. Правка карточки — это работа менеджера, поэтому meetings:manage, а не чтение.
     * @param {string} meetingId
     * @param {MeetingsServiceApplyQualificationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceApplyQualification(
      meetingId: string,
      body: MeetingsServiceApplyQualificationBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsQualificationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceApplyQualification(
        meetingId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceApplyQualification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Отменяет встречу: событие убирается из календаря, клиенту уходит уведомление об отмене. Встреча остаётся видимой со статусом CANCELLED.
     * @param {string} id
     * @param {MeetingsServiceCancelMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceCancelMeeting(
      id: string,
      body: MeetingsServiceCancelMeetingBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsMeeting>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceCancelMeeting(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceCancelMeeting']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Занятость менеджера в выбранном слоте — предупреждение в модалке назначения. Ответ смотрит в календарь целиком, а не только в наши встречи: менеджер занят и своим отпуском, и чужой планёркой.
     * @param {string} [managerId] Пусто — календарь того, кто спрашивает.
     * @param {string} [scheduledStart]
     * @param {string} [scheduledEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceCheckManagerAvailability(
      managerId?: string,
      scheduledStart?: string,
      scheduledEnd?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MeetingsCheckManagerAvailabilityResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.meetingsServiceCheckManagerAvailability(
          managerId,
          scheduledStart,
          scheduledEnd,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceCheckManagerAvailability']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Отклоняет черновик целиком: карточка остаётся как была.
     * @param {string} meetingId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceDiscardQualification(
      meetingId: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsQualificationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceDiscardQualification(
        meetingId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceDiscardQualification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceGetHealth(
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsGetHealthResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceGetHealth(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceGetHealth']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Отдаёт текст приглашения для ручной отправки — кнопка «Скопировать». Отметка mark_sent заводит отправку с каналом MANUAL_COPY: без неё встречи с клиентом без подключённых каналов выпали бы из учёта уведомлений.
     * @param {string} meetingId
     * @param {MeetingsServiceGetInviteTextBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceGetInviteText(
      meetingId: string,
      body: MeetingsServiceGetInviteTextBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsGetInviteTextResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceGetInviteText(
        meetingId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceGetInviteText']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceGetMeeting(
      id: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsMeeting>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceGetMeeting(
        id,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceGetMeeting']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Сводка над списком встреч по тому же фильтру и с тем же скоупом, что ListMeetings (DEV-2085). Ниже GetMeeting намеренно — см. предупреждение о порядке методов выше.
     * @param {string} [clientId]
     * @param {string} [dealId]
     * @param {string} [managerId]
     * @param {Array<MeetingsServiceGetMeetingsStatsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
     * @param {Array<MeetingsServiceGetMeetingsStatsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
     * @param {string} [startFrom]
     * @param {string} [startTo]
     * @param {Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>} [leadTemperatures]  - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
     * @param {number} [minUsefulness]
     * @param {string} [clientQuery]
     * @param {boolean} [pendingSuggestions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceGetMeetingsStats(
      clientId?: string,
      dealId?: string,
      managerId?: string,
      providers?: Array<MeetingsServiceGetMeetingsStatsProvidersEnum>,
      statuses?: Array<MeetingsServiceGetMeetingsStatsStatusesEnum>,
      startFrom?: string,
      startTo?: string,
      leadTemperatures?: Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>,
      minUsefulness?: number,
      clientQuery?: string,
      pendingSuggestions?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsMeetingsStatsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceGetMeetingsStats(
        clientId,
        dealId,
        managerId,
        providers,
        statuses,
        startFrom,
        startTo,
        leadTemperatures,
        minUsefulness,
        clientQuery,
        pendingSuggestions,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceGetMeetingsStats']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Черновик разбора встречи: что модель услышала и чем это отличается от карточки клиента. Право meetings:read.
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceGetQualification(
      meetingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsQualificationResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceGetQualification(
        meetingId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceGetQualification']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Короткоживущая ссылка на аудио записи — источник для плеера. Сам файл наружу не отдаём: ссылка живёт минуты и берётся заново.
     * @param {string} meetingId
     * @param {string} recordingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceGetRecordingAudioUrl(
      meetingId: string,
      recordingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MeetingsGetRecordingAudioUrlResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceGetRecordingAudioUrl(
        meetingId,
        recordingId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceGetRecordingAudioUrl']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Отправки приглашения по встрече: бейджи доставки в блоке «Видеовстречи».
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceListMeetingInvites(
      meetingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsListMeetingInvitesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceListMeetingInvites(
        meetingId,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceListMeetingInvites']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     * Право meetings:read_recordings, а не meetings:read: содержание разговора с клиентом узкее, чем факт встречи. Кто видит встречу, не обязан слышать, о чём на ней говорили.
     * @summary Записи встречи вместе с расшифровками — пост-мит экран.
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceListMeetingRecordings(
      meetingId: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<MeetingsListMeetingRecordingsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.meetingsServiceListMeetingRecordings(meetingId, options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceListMeetingRecordings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Встречи по фильтру: блок «Видеовстречи» в карточке клиента и сделки.
     * @param {string} [clientId]
     * @param {string} [dealId]
     * @param {string} [managerId] Пусто — встречи всех менеджеров, которых видит вызывающий.
     * @param {Array<MeetingsServiceListMeetingsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
     * @param {Array<MeetingsServiceListMeetingsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
     * @param {string} [startFrom] Окно начала встречи.
     * @param {string} [startTo]
     * @param {boolean} [sortDesc] По умолчанию ближайшие сверху; для истории встреч — обратный порядок. При сортировке по оценкам «desc» значит «лучшие сверху».
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>} [leadTemperatures] Фильтры раздела «Видеовстречи» (DEV-2085). Встречи без разбора под фильтры по оценкам не попадают.   - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
     * @param {number} [minUsefulness] Полезность от N (1–5); ноль — не сужать.
     * @param {string} [clientQuery] Поиск по имени клиента: слова запроса как префиксы.
     * @param {MeetingsServiceListMeetingsSortByEnum} [sortBy]
     * @param {boolean} [pendingSuggestions] Только встречи с неразобранными предложениями ИИ (DEV-2831) — те, что считает MeetingsStatsResponse.pending_suggestions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceListMeetings(
      clientId?: string,
      dealId?: string,
      managerId?: string,
      providers?: Array<MeetingsServiceListMeetingsProvidersEnum>,
      statuses?: Array<MeetingsServiceListMeetingsStatusesEnum>,
      startFrom?: string,
      startTo?: string,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      leadTemperatures?: Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>,
      minUsefulness?: number,
      clientQuery?: string,
      sortBy?: MeetingsServiceListMeetingsSortByEnum,
      pendingSuggestions?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsListMeetingsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceListMeetings(
        clientId,
        dealId,
        managerId,
        providers,
        statuses,
        startFrom,
        startTo,
        sortDesc,
        paginationPage,
        paginationPerPage,
        leadTemperatures,
        minUsefulness,
        clientQuery,
        sortBy,
        pendingSuggestions,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceListMeetings']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Разбирает встречу заново по сохранённой расшифровке — кнопка «Разобрать заново» (DEV-2085): для встреч, разобранных до появления оценок, и после правки промпта. Применённый черновик не трогает, неприменённый пересобирает. Право meetings:manage: разбор платный.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceRequalifyMeeting(
      id: string,
      body: object,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsMeeting>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceRequalifyMeeting(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceRequalifyMeeting']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Переносит встречу на другое время. Приглашение клиенту переотправляется: у Meet обновление рассылает сам Calendar, остальные каналы — Ф2.
     * @param {string} id
     * @param {MeetingsServiceRescheduleMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceRescheduleMeeting(
      id: string,
      body: MeetingsServiceRescheduleMeetingBody,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsMeeting>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceRescheduleMeeting(
        id,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceRescheduleMeeting']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Отправляет клиенту приглашение ещё раз — кнопка «Отправить повторно». Каждая попытка остаётся отдельной строкой: неудачную не затираем.
     * @param {string} meetingId
     * @param {MeetingsServiceResendInviteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceResendInvite(
      meetingId: string,
      body: MeetingsServiceResendInviteBody,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsListMeetingInvitesResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceResendInvite(
        meetingId,
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceResendInvite']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Назначает видеовстречу: заводит конференцию у провайдера, включает в ней запись и кладёт встречу в карточку клиента. Право meetings:manage.
     * @param {MeetingsScheduleMeetingRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async meetingsServiceScheduleMeeting(
      body: MeetingsScheduleMeetingRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MeetingsMeeting>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.meetingsServiceScheduleMeeting(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['MeetingsServiceApi.meetingsServiceScheduleMeeting']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * MeetingsServiceApi - factory interface
 * @export
 */
export const MeetingsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = MeetingsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary Применяет выбранные предложения к карточке клиента. Правка карточки — это работа менеджера, поэтому meetings:manage, а не чтение.
     * @param {string} meetingId
     * @param {MeetingsServiceApplyQualificationBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceApplyQualification(
      meetingId: string,
      body: MeetingsServiceApplyQualificationBody,
      options?: any,
    ): AxiosPromise<MeetingsQualificationResponse> {
      return localVarFp
        .meetingsServiceApplyQualification(meetingId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Отменяет встречу: событие убирается из календаря, клиенту уходит уведомление об отмене. Встреча остаётся видимой со статусом CANCELLED.
     * @param {string} id
     * @param {MeetingsServiceCancelMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceCancelMeeting(
      id: string,
      body: MeetingsServiceCancelMeetingBody,
      options?: any,
    ): AxiosPromise<MeetingsMeeting> {
      return localVarFp
        .meetingsServiceCancelMeeting(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Занятость менеджера в выбранном слоте — предупреждение в модалке назначения. Ответ смотрит в календарь целиком, а не только в наши встречи: менеджер занят и своим отпуском, и чужой планёркой.
     * @param {string} [managerId] Пусто — календарь того, кто спрашивает.
     * @param {string} [scheduledStart]
     * @param {string} [scheduledEnd]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceCheckManagerAvailability(
      managerId?: string,
      scheduledStart?: string,
      scheduledEnd?: string,
      options?: any,
    ): AxiosPromise<MeetingsCheckManagerAvailabilityResponse> {
      return localVarFp
        .meetingsServiceCheckManagerAvailability(managerId, scheduledStart, scheduledEnd, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Отклоняет черновик целиком: карточка остаётся как была.
     * @param {string} meetingId
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceDiscardQualification(
      meetingId: string,
      body: object,
      options?: any,
    ): AxiosPromise<MeetingsQualificationResponse> {
      return localVarFp
        .meetingsServiceDiscardQualification(meetingId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetHealth(options?: any): AxiosPromise<MeetingsGetHealthResponse> {
      return localVarFp
        .meetingsServiceGetHealth(options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Отдаёт текст приглашения для ручной отправки — кнопка «Скопировать». Отметка mark_sent заводит отправку с каналом MANUAL_COPY: без неё встречи с клиентом без подключённых каналов выпали бы из учёта уведомлений.
     * @param {string} meetingId
     * @param {MeetingsServiceGetInviteTextBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetInviteText(
      meetingId: string,
      body: MeetingsServiceGetInviteTextBody,
      options?: any,
    ): AxiosPromise<MeetingsGetInviteTextResponse> {
      return localVarFp
        .meetingsServiceGetInviteText(meetingId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetMeeting(id: string, options?: any): AxiosPromise<MeetingsMeeting> {
      return localVarFp
        .meetingsServiceGetMeeting(id, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Сводка над списком встреч по тому же фильтру и с тем же скоупом, что ListMeetings (DEV-2085). Ниже GetMeeting намеренно — см. предупреждение о порядке методов выше.
     * @param {string} [clientId]
     * @param {string} [dealId]
     * @param {string} [managerId]
     * @param {Array<MeetingsServiceGetMeetingsStatsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
     * @param {Array<MeetingsServiceGetMeetingsStatsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
     * @param {string} [startFrom]
     * @param {string} [startTo]
     * @param {Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>} [leadTemperatures]  - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
     * @param {number} [minUsefulness]
     * @param {string} [clientQuery]
     * @param {boolean} [pendingSuggestions]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetMeetingsStats(
      clientId?: string,
      dealId?: string,
      managerId?: string,
      providers?: Array<MeetingsServiceGetMeetingsStatsProvidersEnum>,
      statuses?: Array<MeetingsServiceGetMeetingsStatsStatusesEnum>,
      startFrom?: string,
      startTo?: string,
      leadTemperatures?: Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>,
      minUsefulness?: number,
      clientQuery?: string,
      pendingSuggestions?: boolean,
      options?: any,
    ): AxiosPromise<MeetingsMeetingsStatsResponse> {
      return localVarFp
        .meetingsServiceGetMeetingsStats(
          clientId,
          dealId,
          managerId,
          providers,
          statuses,
          startFrom,
          startTo,
          leadTemperatures,
          minUsefulness,
          clientQuery,
          pendingSuggestions,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Черновик разбора встречи: что модель услышала и чем это отличается от карточки клиента. Право meetings:read.
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetQualification(
      meetingId: string,
      options?: any,
    ): AxiosPromise<MeetingsQualificationResponse> {
      return localVarFp
        .meetingsServiceGetQualification(meetingId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Короткоживущая ссылка на аудио записи — источник для плеера. Сам файл наружу не отдаём: ссылка живёт минуты и берётся заново.
     * @param {string} meetingId
     * @param {string} recordingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceGetRecordingAudioUrl(
      meetingId: string,
      recordingId: string,
      options?: any,
    ): AxiosPromise<MeetingsGetRecordingAudioUrlResponse> {
      return localVarFp
        .meetingsServiceGetRecordingAudioUrl(meetingId, recordingId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Отправки приглашения по встрече: бейджи доставки в блоке «Видеовстречи».
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceListMeetingInvites(
      meetingId: string,
      options?: any,
    ): AxiosPromise<MeetingsListMeetingInvitesResponse> {
      return localVarFp
        .meetingsServiceListMeetingInvites(meetingId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     * Право meetings:read_recordings, а не meetings:read: содержание разговора с клиентом узкее, чем факт встречи. Кто видит встречу, не обязан слышать, о чём на ней говорили.
     * @summary Записи встречи вместе с расшифровками — пост-мит экран.
     * @param {string} meetingId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceListMeetingRecordings(
      meetingId: string,
      options?: any,
    ): AxiosPromise<MeetingsListMeetingRecordingsResponse> {
      return localVarFp
        .meetingsServiceListMeetingRecordings(meetingId, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Встречи по фильтру: блок «Видеовстречи» в карточке клиента и сделки.
     * @param {string} [clientId]
     * @param {string} [dealId]
     * @param {string} [managerId] Пусто — встречи всех менеджеров, которых видит вызывающий.
     * @param {Array<MeetingsServiceListMeetingsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
     * @param {Array<MeetingsServiceListMeetingsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
     * @param {string} [startFrom] Окно начала встречи.
     * @param {string} [startTo]
     * @param {boolean} [sortDesc] По умолчанию ближайшие сверху; для истории встреч — обратный порядок. При сортировке по оценкам «desc» значит «лучшие сверху».
     * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
     * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
     * @param {Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>} [leadTemperatures] Фильтры раздела «Видеовстречи» (DEV-2085). Встречи без разбора под фильтры по оценкам не попадают.   - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
     * @param {number} [minUsefulness] Полезность от N (1–5); ноль — не сужать.
     * @param {string} [clientQuery] Поиск по имени клиента: слова запроса как префиксы.
     * @param {MeetingsServiceListMeetingsSortByEnum} [sortBy]
     * @param {boolean} [pendingSuggestions] Только встречи с неразобранными предложениями ИИ (DEV-2831) — те, что считает MeetingsStatsResponse.pending_suggestions.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceListMeetings(
      clientId?: string,
      dealId?: string,
      managerId?: string,
      providers?: Array<MeetingsServiceListMeetingsProvidersEnum>,
      statuses?: Array<MeetingsServiceListMeetingsStatusesEnum>,
      startFrom?: string,
      startTo?: string,
      sortDesc?: boolean,
      paginationPage?: string,
      paginationPerPage?: string,
      leadTemperatures?: Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>,
      minUsefulness?: number,
      clientQuery?: string,
      sortBy?: MeetingsServiceListMeetingsSortByEnum,
      pendingSuggestions?: boolean,
      options?: any,
    ): AxiosPromise<MeetingsListMeetingsResponse> {
      return localVarFp
        .meetingsServiceListMeetings(
          clientId,
          dealId,
          managerId,
          providers,
          statuses,
          startFrom,
          startTo,
          sortDesc,
          paginationPage,
          paginationPerPage,
          leadTemperatures,
          minUsefulness,
          clientQuery,
          sortBy,
          pendingSuggestions,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Разбирает встречу заново по сохранённой расшифровке — кнопка «Разобрать заново» (DEV-2085): для встреч, разобранных до появления оценок, и после правки промпта. Применённый черновик не трогает, неприменённый пересобирает. Право meetings:manage: разбор платный.
     * @param {string} id
     * @param {object} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceRequalifyMeeting(
      id: string,
      body: object,
      options?: any,
    ): AxiosPromise<MeetingsMeeting> {
      return localVarFp
        .meetingsServiceRequalifyMeeting(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Переносит встречу на другое время. Приглашение клиенту переотправляется: у Meet обновление рассылает сам Calendar, остальные каналы — Ф2.
     * @param {string} id
     * @param {MeetingsServiceRescheduleMeetingBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceRescheduleMeeting(
      id: string,
      body: MeetingsServiceRescheduleMeetingBody,
      options?: any,
    ): AxiosPromise<MeetingsMeeting> {
      return localVarFp
        .meetingsServiceRescheduleMeeting(id, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Отправляет клиенту приглашение ещё раз — кнопка «Отправить повторно». Каждая попытка остаётся отдельной строкой: неудачную не затираем.
     * @param {string} meetingId
     * @param {MeetingsServiceResendInviteBody} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceResendInvite(
      meetingId: string,
      body: MeetingsServiceResendInviteBody,
      options?: any,
    ): AxiosPromise<MeetingsListMeetingInvitesResponse> {
      return localVarFp
        .meetingsServiceResendInvite(meetingId, body, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary Назначает видеовстречу: заводит конференцию у провайдера, включает в ней запись и кладёт встречу в карточку клиента. Право meetings:manage.
     * @param {MeetingsScheduleMeetingRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    meetingsServiceScheduleMeeting(
      body: MeetingsScheduleMeetingRequest,
      options?: any,
    ): AxiosPromise<MeetingsMeeting> {
      return localVarFp
        .meetingsServiceScheduleMeeting(body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * MeetingsServiceApi - object-oriented interface
 * @export
 * @class MeetingsServiceApi
 * @extends {BaseAPI}
 */
export class MeetingsServiceApi extends BaseAPI {
  /**
   *
   * @summary Применяет выбранные предложения к карточке клиента. Правка карточки — это работа менеджера, поэтому meetings:manage, а не чтение.
   * @param {string} meetingId
   * @param {MeetingsServiceApplyQualificationBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceApplyQualification(
    meetingId: string,
    body: MeetingsServiceApplyQualificationBody,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceApplyQualification(meetingId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Отменяет встречу: событие убирается из календаря, клиенту уходит уведомление об отмене. Встреча остаётся видимой со статусом CANCELLED.
   * @param {string} id
   * @param {MeetingsServiceCancelMeetingBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceCancelMeeting(
    id: string,
    body: MeetingsServiceCancelMeetingBody,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceCancelMeeting(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Занятость менеджера в выбранном слоте — предупреждение в модалке назначения. Ответ смотрит в календарь целиком, а не только в наши встречи: менеджер занят и своим отпуском, и чужой планёркой.
   * @param {string} [managerId] Пусто — календарь того, кто спрашивает.
   * @param {string} [scheduledStart]
   * @param {string} [scheduledEnd]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceCheckManagerAvailability(
    managerId?: string,
    scheduledStart?: string,
    scheduledEnd?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceCheckManagerAvailability(managerId, scheduledStart, scheduledEnd, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Отклоняет черновик целиком: карточка остаётся как была.
   * @param {string} meetingId
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceDiscardQualification(
    meetingId: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceDiscardQualification(meetingId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Проба живости через API-gateway: отвечает, если сервис поднят и маршрут доехал до gRPC. Публичный метод — токена не требует.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceGetHealth(options?: RawAxiosRequestConfig) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceGetHealth(options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Отдаёт текст приглашения для ручной отправки — кнопка «Скопировать». Отметка mark_sent заводит отправку с каналом MANUAL_COPY: без неё встречи с клиентом без подключённых каналов выпали бы из учёта уведомлений.
   * @param {string} meetingId
   * @param {MeetingsServiceGetInviteTextBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceGetInviteText(
    meetingId: string,
    body: MeetingsServiceGetInviteTextBody,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceGetInviteText(meetingId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceGetMeeting(id: string, options?: RawAxiosRequestConfig) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceGetMeeting(id, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Сводка над списком встреч по тому же фильтру и с тем же скоупом, что ListMeetings (DEV-2085). Ниже GetMeeting намеренно — см. предупреждение о порядке методов выше.
   * @param {string} [clientId]
   * @param {string} [dealId]
   * @param {string} [managerId]
   * @param {Array<MeetingsServiceGetMeetingsStatsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
   * @param {Array<MeetingsServiceGetMeetingsStatsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
   * @param {string} [startFrom]
   * @param {string} [startTo]
   * @param {Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>} [leadTemperatures]  - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
   * @param {number} [minUsefulness]
   * @param {string} [clientQuery]
   * @param {boolean} [pendingSuggestions]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceGetMeetingsStats(
    clientId?: string,
    dealId?: string,
    managerId?: string,
    providers?: Array<MeetingsServiceGetMeetingsStatsProvidersEnum>,
    statuses?: Array<MeetingsServiceGetMeetingsStatsStatusesEnum>,
    startFrom?: string,
    startTo?: string,
    leadTemperatures?: Array<MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum>,
    minUsefulness?: number,
    clientQuery?: string,
    pendingSuggestions?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceGetMeetingsStats(
        clientId,
        dealId,
        managerId,
        providers,
        statuses,
        startFrom,
        startTo,
        leadTemperatures,
        minUsefulness,
        clientQuery,
        pendingSuggestions,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Черновик разбора встречи: что модель услышала и чем это отличается от карточки клиента. Право meetings:read.
   * @param {string} meetingId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceGetQualification(meetingId: string, options?: RawAxiosRequestConfig) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceGetQualification(meetingId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Короткоживущая ссылка на аудио записи — источник для плеера. Сам файл наружу не отдаём: ссылка живёт минуты и берётся заново.
   * @param {string} meetingId
   * @param {string} recordingId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceGetRecordingAudioUrl(
    meetingId: string,
    recordingId: string,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceGetRecordingAudioUrl(meetingId, recordingId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Отправки приглашения по встрече: бейджи доставки в блоке «Видеовстречи».
   * @param {string} meetingId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceListMeetingInvites(meetingId: string, options?: RawAxiosRequestConfig) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceListMeetingInvites(meetingId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   * Право meetings:read_recordings, а не meetings:read: содержание разговора с клиентом узкее, чем факт встречи. Кто видит встречу, не обязан слышать, о чём на ней говорили.
   * @summary Записи встречи вместе с расшифровками — пост-мит экран.
   * @param {string} meetingId
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceListMeetingRecordings(meetingId: string, options?: RawAxiosRequestConfig) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceListMeetingRecordings(meetingId, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Встречи по фильтру: блок «Видеовстречи» в карточке клиента и сделки.
   * @param {string} [clientId]
   * @param {string} [dealId]
   * @param {string} [managerId] Пусто — встречи всех менеджеров, которых видит вызывающий.
   * @param {Array<MeetingsServiceListMeetingsProvidersEnum>} [providers]  - MEETING_PROVIDER_MEET: Google Meet: конференция заводится событием календаря менеджера, запись включается настройкой пространства и приезжает на Drive организатора.  - MEETING_PROVIDER_TELEMOST: Яндекс Телемост: записи в API нет — её включает человек кнопкой в конференции, файл появляется на Я.Диске организатора.
   * @param {Array<MeetingsServiceListMeetingsStatusesEnum>} [statuses]  - MEETING_STATUS_SCHEDULED: Назначена: конференция создана, приглашение клиенту отправлено.  - MEETING_STATUS_STARTED: Идёт. Только Meet — по событию conferenceRecord.  - MEETING_STATUS_ENDED: Закончилась, запись ещё не приехала. Только Meet.  - MEETING_STATUS_PROCESSING: Запись найдена, идёт извлечение аудио и транскрибация.  - MEETING_STATUS_READY: Транскрипт и саммари готовы, черновик квалификации ждёт менеджера.  - MEETING_STATUS_QUALIFIED: Черновик применён к карточке клиента или сделки.  - MEETING_STATUS_NO_RECORDING: Терминальное: дедлайн ожидания вышел, а записи так и нет. Для Meet — запись не включилась, для Телемоста — её забыли включить руками. Не ошибка пайплайна: встреча состоялась, разбирать нечего.  - MEETING_STATUS_FAILED: Терминальное: пайплайн упал (ffmpeg, files-service, ai-gateway). Чинится повторным запуском, в отличие от NO_RECORDING.  - MEETING_STATUS_CANCELLED: Отменена менеджером; клиенту ушло уведомление об отмене.
   * @param {string} [startFrom] Окно начала встречи.
   * @param {string} [startTo]
   * @param {boolean} [sortDesc] По умолчанию ближайшие сверху; для истории встреч — обратный порядок. При сортировке по оценкам «desc» значит «лучшие сверху».
   * @param {string} [paginationPage] Page number, starting at 1. Zero is treated as the first page.
   * @param {string} [paginationPerPage] Page size. Zero means the default of the service.
   * @param {Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>} [leadTemperatures] Фильтры раздела «Видеовстречи» (DEV-2085). Встречи без разбора под фильтры по оценкам не попадают.   - LEAD_TEMPERATURE_HOT: Готов к сделке в ближайшие недели: бюджет, объект и намерение есть.  - LEAD_TEMPERATURE_WARM: Интерес есть, не хватает бюджета, сроков или решения.  - LEAD_TEMPERATURE_COLD: Смотрит без намерения покупать, изучает рынок, отказывается.
   * @param {number} [minUsefulness] Полезность от N (1–5); ноль — не сужать.
   * @param {string} [clientQuery] Поиск по имени клиента: слова запроса как префиксы.
   * @param {MeetingsServiceListMeetingsSortByEnum} [sortBy]
   * @param {boolean} [pendingSuggestions] Только встречи с неразобранными предложениями ИИ (DEV-2831) — те, что считает MeetingsStatsResponse.pending_suggestions.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceListMeetings(
    clientId?: string,
    dealId?: string,
    managerId?: string,
    providers?: Array<MeetingsServiceListMeetingsProvidersEnum>,
    statuses?: Array<MeetingsServiceListMeetingsStatusesEnum>,
    startFrom?: string,
    startTo?: string,
    sortDesc?: boolean,
    paginationPage?: string,
    paginationPerPage?: string,
    leadTemperatures?: Array<MeetingsServiceListMeetingsLeadTemperaturesEnum>,
    minUsefulness?: number,
    clientQuery?: string,
    sortBy?: MeetingsServiceListMeetingsSortByEnum,
    pendingSuggestions?: boolean,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceListMeetings(
        clientId,
        dealId,
        managerId,
        providers,
        statuses,
        startFrom,
        startTo,
        sortDesc,
        paginationPage,
        paginationPerPage,
        leadTemperatures,
        minUsefulness,
        clientQuery,
        sortBy,
        pendingSuggestions,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Разбирает встречу заново по сохранённой расшифровке — кнопка «Разобрать заново» (DEV-2085): для встреч, разобранных до появления оценок, и после правки промпта. Применённый черновик не трогает, неприменённый пересобирает. Право meetings:manage: разбор платный.
   * @param {string} id
   * @param {object} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceRequalifyMeeting(
    id: string,
    body: object,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceRequalifyMeeting(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Переносит встречу на другое время. Приглашение клиенту переотправляется: у Meet обновление рассылает сам Calendar, остальные каналы — Ф2.
   * @param {string} id
   * @param {MeetingsServiceRescheduleMeetingBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceRescheduleMeeting(
    id: string,
    body: MeetingsServiceRescheduleMeetingBody,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceRescheduleMeeting(id, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Отправляет клиенту приглашение ещё раз — кнопка «Отправить повторно». Каждая попытка остаётся отдельной строкой: неудачную не затираем.
   * @param {string} meetingId
   * @param {MeetingsServiceResendInviteBody} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceResendInvite(
    meetingId: string,
    body: MeetingsServiceResendInviteBody,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceResendInvite(meetingId, body, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Назначает видеовстречу: заводит конференцию у провайдера, включает в ней запись и кладёт встречу в карточку клиента. Право meetings:manage.
   * @param {MeetingsScheduleMeetingRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof MeetingsServiceApi
   */
  public meetingsServiceScheduleMeeting(
    body: MeetingsScheduleMeetingRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return MeetingsServiceApiFp(this.configuration)
      .meetingsServiceScheduleMeeting(body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}

/**
 * @export
 */
export const MeetingsServiceGetMeetingsStatsProvidersEnum = {
  Invalid: 'MEETING_PROVIDER_INVALID',
  Meet: 'MEETING_PROVIDER_MEET',
  Telemost: 'MEETING_PROVIDER_TELEMOST',
} as const
export type MeetingsServiceGetMeetingsStatsProvidersEnum =
  (typeof MeetingsServiceGetMeetingsStatsProvidersEnum)[keyof typeof MeetingsServiceGetMeetingsStatsProvidersEnum]
/**
 * @export
 */
export const MeetingsServiceGetMeetingsStatsStatusesEnum = {
  Invalid: 'MEETING_STATUS_INVALID',
  Scheduled: 'MEETING_STATUS_SCHEDULED',
  Started: 'MEETING_STATUS_STARTED',
  Ended: 'MEETING_STATUS_ENDED',
  Processing: 'MEETING_STATUS_PROCESSING',
  Ready: 'MEETING_STATUS_READY',
  Qualified: 'MEETING_STATUS_QUALIFIED',
  NoRecording: 'MEETING_STATUS_NO_RECORDING',
  Failed: 'MEETING_STATUS_FAILED',
  Cancelled: 'MEETING_STATUS_CANCELLED',
} as const
export type MeetingsServiceGetMeetingsStatsStatusesEnum =
  (typeof MeetingsServiceGetMeetingsStatsStatusesEnum)[keyof typeof MeetingsServiceGetMeetingsStatsStatusesEnum]
/**
 * @export
 */
export const MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum = {
  Invalid: 'LEAD_TEMPERATURE_INVALID',
  Hot: 'LEAD_TEMPERATURE_HOT',
  Warm: 'LEAD_TEMPERATURE_WARM',
  Cold: 'LEAD_TEMPERATURE_COLD',
} as const
export type MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum =
  (typeof MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum)[keyof typeof MeetingsServiceGetMeetingsStatsLeadTemperaturesEnum]
/**
 * @export
 */
export const MeetingsServiceListMeetingsProvidersEnum = {
  Invalid: 'MEETING_PROVIDER_INVALID',
  Meet: 'MEETING_PROVIDER_MEET',
  Telemost: 'MEETING_PROVIDER_TELEMOST',
} as const
export type MeetingsServiceListMeetingsProvidersEnum =
  (typeof MeetingsServiceListMeetingsProvidersEnum)[keyof typeof MeetingsServiceListMeetingsProvidersEnum]
/**
 * @export
 */
export const MeetingsServiceListMeetingsStatusesEnum = {
  Invalid: 'MEETING_STATUS_INVALID',
  Scheduled: 'MEETING_STATUS_SCHEDULED',
  Started: 'MEETING_STATUS_STARTED',
  Ended: 'MEETING_STATUS_ENDED',
  Processing: 'MEETING_STATUS_PROCESSING',
  Ready: 'MEETING_STATUS_READY',
  Qualified: 'MEETING_STATUS_QUALIFIED',
  NoRecording: 'MEETING_STATUS_NO_RECORDING',
  Failed: 'MEETING_STATUS_FAILED',
  Cancelled: 'MEETING_STATUS_CANCELLED',
} as const
export type MeetingsServiceListMeetingsStatusesEnum =
  (typeof MeetingsServiceListMeetingsStatusesEnum)[keyof typeof MeetingsServiceListMeetingsStatusesEnum]
/**
 * @export
 */
export const MeetingsServiceListMeetingsLeadTemperaturesEnum = {
  Invalid: 'LEAD_TEMPERATURE_INVALID',
  Hot: 'LEAD_TEMPERATURE_HOT',
  Warm: 'LEAD_TEMPERATURE_WARM',
  Cold: 'LEAD_TEMPERATURE_COLD',
} as const
export type MeetingsServiceListMeetingsLeadTemperaturesEnum =
  (typeof MeetingsServiceListMeetingsLeadTemperaturesEnum)[keyof typeof MeetingsServiceListMeetingsLeadTemperaturesEnum]
/**
 * @export
 */
export const MeetingsServiceListMeetingsSortByEnum = {
  Invalid: 'MEETING_SORT_BY_INVALID',
  ScheduledStart: 'MEETING_SORT_BY_SCHEDULED_START',
  LeadTemperature: 'MEETING_SORT_BY_LEAD_TEMPERATURE',
  Usefulness: 'MEETING_SORT_BY_USEFULNESS',
} as const
export type MeetingsServiceListMeetingsSortByEnum =
  (typeof MeetingsServiceListMeetingsSortByEnum)[keyof typeof MeetingsServiceListMeetingsSortByEnum]
